"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ModalFooter = ({
  footerButtons,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_styles.StyledModalFooter, props, console.log('footerButtonProps', footerButtons), footerButtons.map(({
  isPrimary,
  text,
  onClick,
  ...rest
}, index) => !isPrimary ? /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, _extends({
  emphasis: "high",
  iconPosition: "left",
  isPrimary: false,
  onClick: onClick,
  text: text,
  theme: "light",
  key: index
}, rest)) : /*#__PURE__*/_react.default.createElement(_atoms.Button, _extends({
  "data-dismiss": "modal",
  "aria-label": "Close",
  size: "small",
  onClick: onClick,
  text: text,
  key: index
}, rest))));

exports.ModalFooter = ModalFooter;
ModalFooter.propTypes = {
  footerButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    onClick: _propTypes.default.func.isRequired,
    text: _propTypes.default.string.isRequired,
    isPrimary: _propTypes.default.bool.isRequired
  }))
};